// extracted by mini-css-extract-plugin
module.exports = {"environmentSwitch":"management-app_environmentSwitch__G9e3l","environmentBanner":"management-app_environmentBanner__Xk4tD"};